import React from 'react'
import { Team } from '../../component/about/Team'
import { PresidentMessage } from '../../component/about/PresidentMessage'

export default function MessagePage() {
  return (
    <>
      <PresidentMessage />
    </>
  )
}
